export default __webpack_public_path__ + "static/media/kuvendiIcon.8cd9922c.png";